import type { Components, Theme } from '@mui/material/styles';

export const MuiList: Components<Theme>['MuiList'] = {
  styleOverrides: {
    root: {
      '--ListItem-gap': '16px',
    },
  },
};
